import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RedirectExternalBrowser = () => {
  const location = useLocation();
  const queryStringParams = new URLSearchParams(location.search);

  const externalUrl = queryStringParams.get('url');

  useEffect(() => {
    window.open(`kakaotalk://web/openExternal?url=${externalUrl}`);
  }, []);

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#ffffff',
    padding: '20px',
  };

  const logoContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px',
  };

  const logoStyle = {
    width: '40px', // 로고 크기 조정
    marginRight: '10px',
  };

  const titleStyle = {
    fontSize: '24px',
    fontWeight: 'bold',
  };

  const descriptionStyle = {
    fontSize: '16px',
    color: '#333',
    textAlign: 'center',
    lineHeight: '1.6',
  };

  return (
    <div style={containerStyle}>
      <div style={logoContainerStyle}>
        <img src="assets/images/nhis/group_640.png" alt="헬스업 로고" style={logoStyle} />
        <h1 style={titleStyle}>헬스업</h1>
      </div>
      <p style={descriptionStyle}>
        동의 받은 사용자 대상의
        <br />
        건강 서비스 분석을 위해 연결 중입니다.
        <br />
        잠시만 기다려주세요.
      </p>
    </div>
  );
};

export default RedirectExternalBrowser;
